import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from './actionTypes';
import {
  addLessonSuccess,
  addLessonFailure,
  fetchLessonsSuccess,
  fetchLessonsFailure,
  updateLessonSuccess,
  updateLessonFailure,
  deleteLessonSuccess,
  deleteLessonFailure,
} from './actions';
import { showSuccess } from 'helpers/notification_helper';
import axiosInstance from 'pages/Utility/axiosInstance';

// ============================
// API CALLS
// ============================
const addLessonAPI = async (data) => {
  const response = await axiosInstance.post('V1/lessons', data);
  return response.data;
};

const fetchLessonsAPI = async (params) => {
  const response = await axiosInstance.get('V1/lessons', { params });
  return response.data;
};

const updateLessonAPI = async (id, data) => {
  const response = await axiosInstance.put(`V1/lessons/${id}`, data);
  return response.data;
};

const deleteLessonAPI = async (id) => {
  const response = await axiosInstance.delete(`V1/lessons/${id}`);
  return response.data;
};

// ============================
// WORKER SAGAS
// ============================

//  Add Lesson
function* addLessonSaga(action) {
  try {
    const { data, callback } = action.payload;
    const result = yield call(addLessonAPI, data);
    yield put(addLessonSuccess(result));
    showSuccess('Lesson added successfully!');
    if (callback) callback(null, result);
  } catch (error) {
    const errMsg = error.response?.data || error.message;
    yield put(addLessonFailure(errMsg));
    if (action.payload.callback) action.payload.callback(errMsg);
  }
}

//  Fetch Lessons
function* fetchLessonsSaga(action) {
  try {
    console.log(" FETCH LESSONS SAGA TRIGGERED:", action.payload);
    const result = yield call(fetchLessonsAPI, action.payload);
    yield put(fetchLessonsSuccess(result));
  } catch (error) {
    const errMsg = error.response?.data || error.message;
    yield put(fetchLessonsFailure(errMsg));
  }
}

//  Update Lesson
function* updateLessonSaga(action) {
  try {
    const { id, data, callback } = action.payload;

    // Call API
    const result = yield call(updateLessonAPI, id, data);
    console.log(" Update API result:", result);

    //  Extract only the updated lesson object
    const updatedLesson = result.lesson;

    //  Dispatch to reducer
    yield put(updateLessonSuccess(updatedLesson));

    //  Show success message
    showSuccess(result?.message || 'Lesson updated successfully!');

    if (callback) callback(null, updatedLesson);
  } catch (error) {
    const errMsg = error.response?.data || error.message;
    yield put(updateLessonFailure(errMsg));
    if (action.payload.callback) action.payload.callback(errMsg);
  }
}



//  Delete Lesson
function* deleteLessonSaga(action) {
  try {
    const result = yield call(deleteLessonAPI, action.payload);
    yield put(deleteLessonSuccess(result));
    showSuccess('Lesson deleted successfully!');
  } catch (error) {
    const errMsg = error.response?.data || error.message;
    yield put(deleteLessonFailure(errMsg));
  }
}

// ============================
// WATCHERS
// ============================
export default function* lessonSaga() {
  yield takeLatest(types.ADD_LESSON_REQUEST, addLessonSaga);
  yield takeLatest(types.FETCH_LESSONS_REQUEST, fetchLessonsSaga);
  yield takeLatest(types.UPDATE_LESSON_REQUEST, updateLessonSaga);
  yield takeLatest(types.DELETE_LESSON_REQUEST, deleteLessonSaga);
}
